import winner1 from "../assets/winners/Chandrasekar.jpeg";
import winner2 from "../assets/winners/Ranjitha.jpeg";
import "../styles/winners.scss";

function Winners() {
  return (
    <div className="winner-container">
      <h2 className="winner-heading">Winners of PEN Scholar Awards</h2>
      <div className="winner-grid">
        <div className="winner-card">
          <img
            src={winner1}
            alt="Dr. D. Chandrasekar"
            className="winner-image"
          />
          <h3 className="winner-name">Dr. D. Chandrasekar</h3>
          <p className="winner-category">(Social Sciences Category)</p>
          <p className="winner-topic">
            Topic: “Role of Social Capital in Determining the Development of
            Dalits in the Village Economy of Tamil Nadu, India”
          </p>
        </div>
        <div className="winner-card">
          <img src={winner2} alt="Dr. R. Ranjitha" className="winner-image" />
          <h3 className="winner-name">Dr. R. Ranjitha</h3>
          <p className="winner-category">(Gender Studies Category)</p>
          <p className="winner-topic">
            Topic: “Relationship of Personal Empowerment, Workplace Factors, and
            Wellbeing among Women Millennials”
          </p>
        </div>
      </div>
    </div>
  );
}

export default Winners;
